// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bmv[data-v-539d1abb]{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-column-gap:2rem}", ""]);
// Exports
module.exports = exports;
